import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from 'src/app/services/env.service';
import { UserService } from 'src/app/core/services/user.service';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class CallContactService {
  readonly baseUrl = `${this.env.URL_API_V1}/contact`;
  constructor(
    private env: EnvService,
    private readonly http: HttpClient,
    private userService: UserService
  ) {}

  createCallContact(callContact) {
    return this.http.post<any[]>(`${this.baseUrl}/create`, callContact);
  }

  getCallContact(id) {
    return this.http.get<any[]>(`${this.baseUrl}/getContact/${id}`);
  }

  getCallContacts(id) {
    return this.http.get<any[]>(`${this.baseUrl}/allContactOfCase/${id}`);
  }

  updateCallContact(id, callContact) {
    return this.http.put<any[]>(`${this.baseUrl}/updateContact/${id}`, {
      callContact,
      user: this.userService.currentUser,
    });
  }
  deleteCallContact(id) {
    return this.http.put<any[]>(
      `${this.baseUrl}/deleteContact/${id}`,
      this.userService.currentUser
    );
  }
}
